import { render, staticRenderFns } from "./DocuDetail.vue?vue&type=template&id=5360034c&scoped=true&"
import script from "./DocuDetail.vue?vue&type=script&lang=js&"
export * from "./DocuDetail.vue?vue&type=script&lang=js&"
import style0 from "./DocuDetail.vue?vue&type=style&index=0&id=5360034c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5360034c",
  null
  
)

export default component.exports